import * as React from 'react';

const commonMessageValues = {
  b: <br/>,
  divider: <div className="ui hidden divider"/>
};

export default commonMessageValues;